export enum EmployeeStatusEnum {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED',
}
